import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-53cd53b9")
const _hoisted_1 = { class: "flex flex-col lg:flex-row justify-between px-5 lg:px-0 mb-5 mt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "font-ops mb-1 lg:mb-0" }, " Pending Withdrawal ", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Cancel Withdrawal ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Withdraw FLAKE ")
_popScopeId()

import { computed, watch } from 'vue';
import { flatten } from 'lodash';
import useUserFlakeInfosQuery from '@/composables/queries/useUserFlakeInfosQuery';
import { TransactionResponse } from '@ethersproject/abstract-provider';
import { balancerService } from '@/services/balancer/balancer.service';
import useTransactions from '@/composables/useTransactions';
import useEthers from '@/composables/useEthers';
import useWeb3 from '@/services/web3/useWeb3';
import { BaseFlakeInfos } from '@/services/balancer/subgraph/types';
// @ts-ignore
import Table from './Table.vue';
import { bnum } from '@/lib/utils';

/**
 * TYPES
 */
type Props = {
  userLeaveRequestsQuery: any;
  baseFlakeInfos: BaseFlakeInfos[];
  loading: boolean;
};

/**
 * PROPS
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default _defineComponent({
  props: {
    userLeaveRequestsQuery: { type: null, required: true },
    baseFlakeInfos: { type: Array, required: true },
    loading: { type: Boolean, required: true, default: false }
  } as unknown as undefined,
  setup(__props: {
  userLeaveRequestsQuery: any;
  baseFlakeInfos: BaseFlakeInfos[];
  loading: boolean;
}) {

const props = __props


/**
 * QUERIES
 */
const { data: userFlakeInfosQuery } = useUserFlakeInfosQuery();
const pendingFirstIndex = computed(() =>
  userFlakeInfosQuery.value && userFlakeInfosQuery.value[0]
    ? userFlakeInfosQuery.value[0].pendingFirstIndex
    : ''
);

/**
 * COMPUTED
 */
const TXTYPE = ['leave', 'cancelLeave'];
const userLeaveRequests = computed(() =>
  props.userLeaveRequestsQuery.data.value
    ? flatten(
        props.userLeaveRequestsQuery.data.value.pages.map(
          page => page.userLeaveRequests
        )
      )
    : []
);

const withdrawFlakeBtnDisabled = computed(() => {
  if (userLeaveRequests.value && props.baseFlakeInfos) {
    const leavingTerm = props.baseFlakeInfos[0].leavingTerm;
    const fliterLeaveRequests = userLeaveRequests.value.filter(i =>
      // @ts-ignore
      bnum(i.timestamp)
        .plus(leavingTerm)
        .times(1000)
        .lt(Date.now())
    );
    return !fliterLeaveRequests.length;
  } else {
    return true;
  }
});

const isLoadingUserLeaveRequests = computed(
  () => props.userLeaveRequestsQuery.isLoading.value
);
const userLeaveRequestsHasNextPage = computed(
  () => props.userLeaveRequestsQuery.hasNextPage?.value
);
const userLeaveRequestsIsFetchingNextPage = computed(
  () => props.userLeaveRequestsQuery.isFetchingNextPage?.value
);

/**
 * METHODS
 */
function loadMoreUserLeaveRequests() {
  props.userLeaveRequestsQuery.fetchNextPage.value();
}
const { addTransaction } = useTransactions();
const { txListener } = useEthers();
const { getProvider } = useWeb3();

async function handleTx(type): Promise<TransactionResponse> {
  const provider = getProvider();
  try {
    const tx = await balancerService.farmPools.normalFarm[type](provider);

    addTransaction({
      id: tx.hash,
      type: 'tx',
      action: type,
      summary: type === TXTYPE[0] ? 'Withdraw FLAKE' : 'Cancel Withdrawal',
      details: {
        name: 'MyStakeFlake'
      }
    });

    txListener(tx, {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onTxConfirmed: async () => {},
      onTxFailed: () => {
        console.log(`${type} FLAKE failed`);
      }
    });

    return tx;
  } catch (e) {
    console.log(e);
    return Promise.reject(`${type} FLAKE failed`);
  }
}

/**
 * WATCHERS
 */
watch(pendingFirstIndex, () => {
  props.userLeaveRequestsQuery.refetch.value();
});

return (_ctx: any,_cache: any) => {
  const _component_BalBtn = _resolveComponent("BalBtn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", null, [
        _createVNode(_component_BalBtn, {
          size: "sm",
          disabled: _unref(userLeaveRequests).length === 0,
          onClick: _cache[0] || (_cache[0] = () => handleTx('cancelLeave')),
          class: "mr-4 baseBtn",
          color: "none",
          changeType: "cancelUnstake"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_BalBtn, {
          disabled: _unref(withdrawFlakeBtnDisabled),
          size: "sm",
          onClick: _cache[1] || (_cache[1] = () => handleTx('leave')),
          class: "mr-4 baseBtn",
          color: "gray-950",
          changeType: "withdrawFlake"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createVNode(Table, {
      "base-flake-infos": __props.baseFlakeInfos,
      "user-leave-requests": _unref(userLeaveRequests),
      "is-loading": __props.loading || _unref(isLoadingUserLeaveRequests),
      "is-loading-more": _unref(userLeaveRequestsIsFetchingNextPage),
      "is-paginated": _unref(userLeaveRequestsHasNextPage),
      onLoadMore: loadMoreUserLeaveRequests
    }, null, 8, ["base-flake-infos", "user-leave-requests", "is-loading", "is-loading-more", "is-paginated"])
  ], 64))
}
}

})